import { SponsorRequest } from 'EstraSponsor'

/** A function that checks if the sponsor request has changes */
export const sponsorRequestHasChanges = (
  sponsorRequest: SponsorRequest
): boolean =>
  !!(
    sponsorRequest.changes?.changes?.financial_contribution ||
    sponsorRequest.changes?.changes?.technical_contribution ||
    sponsorRequest.changes?.changes?.logo_visibility ||
    sponsorRequest.changes?.changes?.benefits
  )
